// src/components/meeting/panels/MobileCreatePanel.jsx
import MeetingForm from "../MeetingForm";

// 모바일 회의 등록 패널
export default function MobileCreatePanel({
  projectId,
  selectedDate,
  existingCompositeKeySet,
  onSaved,
  onClose,
}) {
  return (
    <MeetingForm
      mode="create"
      projectId={projectId}
      initialDate={selectedDate}
      existingCompositeKeySet={existingCompositeKeySet}
      originalCompositeKey={null}
      onCancel={onClose}
      onSaved={onSaved}
      isMobile={true} // 모바일 전용 폼 활성화
    />
  );
}
